const moment = require('moment');

export const formatDate = (value, format = 'YYYY/MM/DD') => {
  if (value) {
    return moment(value).format(format);
  }
  return null;
};

export const getImageUrl = (path) => {
  if (path) {
    return process.env.VUE_APP_FILE_URL + '/' + path.replace('public/', '');
  }

  return null;
};

export const scrollToInvalidInput = (errorClass = 'error-msg') => {
  const el = document.querySelectorAll(`.${errorClass}`);
  if (el && el[0]) {
    el[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

export const replaceImgByDefault = (event) => {
  event.target.src = require('@/assets/images/img_unavailable.jpg');
  event.target.style = 'object-fit: cover !important';
};

export const truncate = (string, limit = 20, ending = '...') => {
  if (string.length <= limit) {
    return string;
  }

  return string.slice(0, limit) + ending;
};

export const getDeviceInformation = () => {
  const pixelRatio = parseFloat(window.devicePixelRatio.toFixed(2));
  const deviceInformation = {
    win_width: null,
    win_height: null,
    pixel_ratio: pixelRatio,
  };
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent);

  if (isAndroid) {
    deviceInformation.win_width = Math.round(window.screen.width * pixelRatio);
    deviceInformation.win_height = Math.round(window.screen.height * pixelRatio);
  } else if (isIOS) {
    deviceInformation.win_width = window.screen.width;
    deviceInformation.win_height = window.screen.height;
  } else {
    deviceInformation.win_width = window.innerWidth;
    deviceInformation.win_height = window.innerHeight;
  }

  return deviceInformation;
};
